export default __webpack_public_path__ + "static/media/Configurações.d91e933d.svg";